export default __webpack_public_path__ + "static/Brandon-Medium-500-ebd80d67400ceed60ef90887eff77e6f.woff2";